<div class="d-flex align-items-center mb-3">
	<div class="flex-grow-1">
		<h6 class="text-muted text-uppercase fw-semibold mb-1">Employees assigned to view</h6>
		<h5 class="mb-0"><i class="{{ selectedView.icon }} me-1" *ngIf="selectedView.icon"></i>{{ selectedView.label | translate }}</h5>
	</div>
	<span class="badge badge-soft-primary fs-12">{{ assignedCount }} of {{ employeeUsers.length }} assigned</span>
</div>

<div class="row">
	<div class="col-12">
		<ngx-datatable class="material striped" [rows]="employeeUsers" [columnMode]="columnMode.force" [headerHeight]="50" [footerHeight]="70" rowHeight="auto" [scrollbarH]="true" [loadingIndicator]="isLoading">
			<ngx-datatable-column prop="isActive" name="" headerClass="cell-center title-header" cellClass="cell-center" [width]="80" [maxWidth]="80" [minWidth]="80" [resizeable]="false" [sortable]="false">
				<ng-template ngx-datatable-header-template>
					<div class="form-check form-switch form-switch-md form-switch-success d-inline-block" title="Assign all">
						<input class="form-check-input" type="checkbox" role="switch" [disabled]="disableCheckbox || !employeeUsers.length" [checked]="assignAll" (click)="assignAllCallers()" />
					</div>
				</ng-template>
				<ng-template let-row="row" ngx-datatable-cell-template>
					<div class="form-check form-switch form-switch-md form-switch-success d-inline-block">
						<input class="form-check-input" type="checkbox" role="switch" [disabled]="disableCheckbox" [checked]="row.isActive == 1" (click)="checkBoxClick(row, $event)" />
					</div>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column prop="full_name" name="Name" headerClass="title-header" [width]="200">
				<ng-template let-row="row" ngx-datatable-cell-template>
					<span class="fw-medium">{{ row.full_name }}</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column prop="role" name="Role" headerClass="cell-center title-header" cellClass="cell-center" [width]="110" [maxWidth]="110">
				<ng-template let-row="row" ngx-datatable-cell-template>
					<span *ngIf="row.role === 'SADM'" class="badge bg-dark">Super Admin</span>
					<span *ngIf="row.role === 'ADM'" class="badge bg-danger">Admin</span>
					<span *ngIf="row.role === 'CAL'" class="badge bg-success">Caller</span>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column prop="login" name="Login" headerClass="cell-center title-header" cellClass="cell-center" [width]="130" [maxWidth]="130"></ngx-datatable-column>
			<ngx-datatable-column prop="email" name="Email" headerClass="title-header" [width]="250"></ngx-datatable-column>

			<!-- Custom loading template -->
			<ng-template ngx-datatable-loading-template>
				<div class="d-flex justify-content-center align-items-center p-4">
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
					<span class="ms-2">Loading employee permissions...</span>
				</div>
			</ng-template>

			<ngx-datatable-footer *ngIf="true">
				<ng-template ngx-datatable-footer-template let-rowCount="rowCount">
					<div class="title-footer"><strong>Total Records: </strong> {{ rowCount }}</div>
				</ng-template>
			</ngx-datatable-footer>
		</ngx-datatable>
	</div>
</div>
